import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class GroupListService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

  constructor(private http: Http) { }

  searchUser(token, groupName, groupStatus, orderby, sort, page) {
    

    
    
    
    
    
    

    page = page * globalConst.paginationSkip;

    var url = "";

    if (groupStatus == "") {
      url = "/groups/v1/getgroups/?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=IsProcesso eq false and startswith(tolower(Nome),tolower('" + groupName + "'))";
    } else {
      url = "/groups/v1/getgroups/?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=IsProcesso eq false and startswith(tolower(Nome),tolower('" + groupName + "')) and Ativo eq " + groupStatus
    }

    return this.http
      .get(this.apiUrl + url, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/group/service/group-list/group-list.service.ts